import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './components/App';
import { SubscriptionProvider } from './contexts/SubscriptionContext';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#9b59b6', // Roxo
      light: '#c39bd3',
      dark: '#7d3c98',
    },
    secondary: {
      main: '#c74375', // Rosa
      light: '#e91e63',
      dark: '#ad1457',
    },
    background: {
      default: '#0a0a0a', // Preto
      paper: '#1a1a1a', // Preto claro
    },
    text: {
      primary: '#e0e0e0', // Prata claro
      secondary: '#b0b0b0', // Prata médio
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  // StrictMode disabled temporarily for WebSocket testing
  // <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SubscriptionProvider>
        <App />
      </SubscriptionProvider>
    </ThemeProvider>
  // </React.StrictMode>
);